export default __webpack_public_path__ + "static/media/inActiveHeaderQuestion.8d5a67f7.svg";